import type { StaffCustomerMemoryApi } from "@lafayette/api-client";
import { createContext, type ReactNode, useContext } from "react";

// What the customer memory pages need from outside: the typed API client and the clock. The admin app
// supplies the real ones (`admin-runtime.ts`); a test supplies a fake API.

export type MemoryRuntime = Readonly<{
  api: StaffCustomerMemoryApi;
  now: () => Date;
}>;

const RuntimeContext = createContext<MemoryRuntime | null>(null);

export function MemoryRuntimeProvider({
  value,
  children,
}: Readonly<{ value: MemoryRuntime; children: ReactNode }>) {
  return <RuntimeContext.Provider value={value}>{children}</RuntimeContext.Provider>;
}

export function useMemoryRuntime(): MemoryRuntime {
  const runtime = useContext(RuntimeContext);
  if (runtime === null) throw new Error("The customer pages need a MemoryRuntimeProvider.");
  return runtime;
}

/** The runtime when a provider is mounted, else `null`: for the shell, which may stand without the customer pages (a unit test). */
export function useOptionalMemoryRuntime(): MemoryRuntime | null {
  return useContext(RuntimeContext);
}
